/**
 * Combine class names with **clsx** and resolve Tailwind conflicts with **tailwind-merge** (last utility wins).
 * Peer deps: `clsx`, `tailwind-merge` (see `_shared/frontend/package.json`).
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
